import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('playlists', { params }).then(result => result.data)
  },
  get(id) {
    return axios.get(`playlists/${id}`).then(result => result.data)
  },
  store(data) {
    return axios.post('playlists', data).then(result => result.data)
  },
  update(id, data) {
    return axios.patch(`playlists/${id}`, data).then(result => result.data)
  },
  clone(id, data) {
    return axios.post(`playlists/${id}/clone`, data).then(result => result.data)
  },
  delete(ids) {
    return axios.post('playlists/delete', {
      playlist_ids: ids
    }).then(result => result.data)
  },
  addFilesToPlaylist(playlistId, fileIds) {
    return axios.post(`playlists/${playlistId}/add-library-files`, {
      library_file_ids: fileIds
    }).then(result => result.data)
  },
  removeFilesFromPlaylist(playlistId, fileIds) {
    return axios.post(`playlists/${playlistId}/remove-library-files`, {
      library_file_ids: fileIds
    }).then(result => result.data)
  },
  fetchDisabledFiles(id) {
    return axios.get(`playlists/${id}/disabled-library-files-list`).then(result => result.data)
  },
  toggleFileDisabled(playlistId, fileId) {
    return axios.post(`playlists/${playlistId}/library-files/${fileId}/toggle-disabled`).then(result => result.data)
  }
}
